module.exports = __webpack_public_path__ + "static/img/aa-12.f581f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-12.png
// module id = 4EfO
// module chunks = 1